import { getAbsoluteElementOffsetTop } from "./DOMutils";

// TODO: Extract nav element and reuse (here and every other place)
// TODO: Add utility function to get css variables, and reuse the --nav-height variable for the nav offset

const nav = document.querySelector(".js-module-nav");

export const scrollToElement = (id, e = null, pushToHistory = true, behavior = "smooth") => {
    if (e) e.preventDefault();

    if (!id || id === "#") return;

    const element = document.querySelector(id);
    let elementOffsetTop = 0;

    if (!element) return;

    elementOffsetTop = getAbsoluteElementOffsetTop(element);

    if (nav) elementOffsetTop -= nav.offsetHeight + 20;

    window.scrollTo({ top: elementOffsetTop, left: 0, behavior });

    if (pushToHistory) history.pushState(null, null, id);
};

const handleWindowLoadEvent = () => {
    const hash = window.location.hash;

    if (hash) setTimeout(() => scrollToElement(hash), 50);
};

window.addEventListener("load", handleWindowLoadEvent);

export default function() {
    document
        .querySelectorAll('a[href^="#"]')
        .forEach((anchorLink) =>
            anchorLink.addEventListener("click", scrollToElement.bind(null, anchorLink.getAttribute("href")))
        );
}
